var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"slide-top-button",on:{"click":function($event){return _vm.$emit('onScroll')}}},[_c('i',{staticClass:"material-icons md-34 color_white"},[_vm._v("arrow_upward")])])}
var staticRenderFns = []

export { render, staticRenderFns }